const ConfigValidationConstants = {
  GET_CONFIG_VALIDATION_SUCCESS: "GET_CONFIG_VALIDATION_SUCCESS",
  GET_CONFIG_VALIDATIONT_FAILURE: "GET_CONFIG_VALIDATIONT_FAILURE",
};

export default ConfigValidationConstants;
